import { Translation } from 'primeng/api';

/**
 * Deutsche Übersetzung für alle PrimeNG-Komponenten (Datepicker, Tabellen-Filter,
 * Paginator, Upload, ...). Wird in app.config.ts an providePrimeNG übergeben und
 * dort in die englischen Standardwerte gemerged.
 */
export const primeNgDe: Translation = {
    startsWith: 'Beginnt mit',
    contains: 'Enthält',
    notContains: 'Enthält nicht',
    endsWith: 'Endet mit',
    equals: 'Ist gleich',
    notEquals: 'Ist ungleich',
    noFilter: 'Kein Filter',
    lt: 'Kleiner als',
    lte: 'Kleiner oder gleich',
    gt: 'Größer als',
    gte: 'Größer oder gleich',
    is: 'Ist',
    isNot: 'Ist nicht',
    before: 'Vor',
    after: 'Nach',
    dateIs: 'Datum ist',
    dateIsNot: 'Datum ist nicht',
    dateBefore: 'Datum ist vor',
    dateAfter: 'Datum ist nach',
    clear: 'Zurücksetzen',
    apply: 'Anwenden',
    matchAll: 'Alle erfüllen',
    matchAny: 'Mindestens eine erfüllen',
    addRule: 'Regel hinzufügen',
    removeRule: 'Regel entfernen',
    accept: 'Ja',
    reject: 'Nein',
    choose: 'Auswählen',
    completed: 'Abgeschlossen',
    upload: 'Hochladen',
    cancel: 'Abbrechen',
    pending: 'Ausstehend',
    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
    dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    chooseYear: 'Jahr wählen',
    chooseMonth: 'Monat wählen',
    chooseDate: 'Datum wählen',
    prevDecade: 'Vorheriges Jahrzehnt',
    nextDecade: 'Nächstes Jahrzehnt',
    prevYear: 'Vorheriges Jahr',
    nextYear: 'Nächstes Jahr',
    prevMonth: 'Vorheriger Monat',
    nextMonth: 'Nächster Monat',
    prevHour: 'Vorherige Stunde',
    nextHour: 'Nächste Stunde',
    prevMinute: 'Vorherige Minute',
    nextMinute: 'Nächste Minute',
    prevSecond: 'Vorherige Sekunde',
    nextSecond: 'Nächste Sekunde',
    am: 'vorm.',
    pm: 'nachm.',
    dateFormat: 'dd.mm.yy',
    // Wochenstart Montag für alle Datepicker
    firstDayOfWeek: 1,
    today: 'Heute',
    weekHeader: 'KW',
    weak: 'Schwach',
    medium: 'Mittel',
    strong: 'Stark',
    passwordPrompt: 'Passwort eingeben',
    emptyMessage: 'Keine Einträge gefunden',
    searchMessage: 'Suchergebnisse verfügbar',
    selectionMessage: '{0} Einträge ausgewählt',
    emptySelectionMessage: 'Kein Eintrag ausgewählt',
    emptySearchMessage: 'Keine Ergebnisse gefunden',
    emptyFilterMessage: 'Keine Ergebnisse gefunden',
    fileChosenMessage: 'Dateien',
    noFileChosenMessage: 'Keine Datei ausgewählt',
    aria: {
        trueLabel: 'Wahr',
        falseLabel: 'Falsch',
        nullLabel: 'Nicht ausgewählt',
        star: '1 Stern',
        stars: '{star} Sterne',
        selectAll: 'Alle Einträge ausgewählt',
        unselectAll: 'Alle Einträge abgewählt',
        close: 'Schließen',
        previous: 'Zurück',
        next: 'Weiter',
        navigation: 'Navigation',
        scrollTop: 'Nach oben scrollen',
        moveTop: 'Ganz nach oben',
        moveUp: 'Nach oben',
        moveDown: 'Nach unten',
        moveBottom: 'Ganz nach unten',
        moveToTarget: 'Zur Zielliste verschieben',
        moveToSource: 'Zur Quellliste verschieben',
        moveAllToTarget: 'Alle zur Zielliste verschieben',
        moveAllToSource: 'Alle zur Quellliste verschieben',
        pageLabel: '{page}',
        firstPageLabel: 'Erste Seite',
        lastPageLabel: 'Letzte Seite',
        nextPageLabel: 'Nächste Seite',
        prevPageLabel: 'Vorherige Seite',
        rowsPerPageLabel: 'Zeilen pro Seite',
        previousPageLabel: 'Vorherige Seite',
        jumpToPageDropdownLabel: 'Zu Seite springen (Auswahl)',
        jumpToPageInputLabel: 'Zu Seite springen (Eingabe)',
        selectRow: 'Zeile ausgewählt',
        unselectRow: 'Zeile abgewählt',
        expandRow: 'Zeile ausgeklappt',
        collapseRow: 'Zeile eingeklappt',
        showFilterMenu: 'Filtermenü anzeigen',
        hideFilterMenu: 'Filtermenü ausblenden',
        filterOperator: 'Filter-Operator',
        filterConstraint: 'Filter-Bedingung',
        editRow: 'Zeile bearbeiten',
        saveEdit: 'Änderung speichern',
        cancelEdit: 'Änderung verwerfen',
        listView: 'Listenansicht',
        gridView: 'Rasteransicht',
        slide: 'Folie',
        slideNumber: '{slideNumber}',
        zoomImage: 'Bild vergrößern',
        zoomIn: 'Vergrößern',
        zoomOut: 'Verkleinern',
        rotateRight: 'Nach rechts drehen',
        rotateLeft: 'Nach links drehen',
        listLabel: 'Optionsliste',
        selectColor: 'Farbe auswählen',
        removeLabel: 'Entfernen',
        browseFiles: 'Dateien durchsuchen',
        maximizeLabel: 'Maximieren',
        minimizeLabel: 'Minimieren'
    }
};
